import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames'

const IconLnSVG = ({color, className, ...rest}) => {
    return (
        <svg {...rest} width="23.831" height="22.778" viewBox="0 0 23.831 22.778" fill="none"
             className={classNames(['svg-icon svg-linkedin', className])}>
            <path className="icon-linkedin_a" fill={color}
                  d="M46.3,62.687h5.107V78.056H46.3Zm2.588-7.409a2.662,2.662,0,1,0-.067,5.31h.033a2.663,2.663,0,1,0,.034-5.31Zm15.059,7.048a5.07,5.07,0,0,0-4.6,2.537V62.687H54.237c.068,1.442,0,15.369,0,15.369h5.109V69.473a3.517,3.517,0,0,1,.168-1.247,2.8,2.8,0,0,1,2.62-1.868c1.85,0,2.589,1.41,2.589,3.475v8.223h5.108V69.243C69.831,64.522,67.312,62.326,63.949,62.326Z"
                  transform="translate(-46 -55.278)"></path>
        </svg>

    );
};

IconLnSVG.propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

IconLnSVG.defaultProps = {
    color: '#fff',
    className: '',
};

export default IconLnSVG;